export const APP_NAME = 'EcoleMinds';

export const API_CONFIG = {
  BASE_URL: (import.meta as any).env.VITE_API_BASE_URL || 'http://localhost:8000/api/v1',
  TIMEOUT: 30000,
};

export const STORAGE_KEYS = {
  TOKEN: 'ecm_token',
  SESSION: 'ecm_session',
  REFRESH_TOKEN: 'ecm_refresh_token',
  UTM_DATA: 'ecm_utm_data',
  SESSION_ID: 'ecm_session_id',
};

export const USER_ROLES = {
  USER: 'user',
  TRAINER: 'trainer',
  ADMIN: 'admin',
} as const;

export const PAYMENT_CONFIG = {
  CURRENCY: 'INR',
  THEME_COLOR: '#0f172a',
};
